














































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import TsUpload from "@/components/upload.vue";

@Component({
  components: {
    TsUpload
  }
})
export default class extends Mixins(MyForm) {
  @Prop() itemTypes!: any[];

  itemType = "1";

  selectItemType(val: string) {
    this.itemType = val;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("options/edititem", {
              id: this.editId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  async mounted() {
    const res = await this.$store.dispatch("options/getitem", {
      id: this.editId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.formData = res.Data;
      this.itemType = res.Data.item_type;
    }
  }
}
